import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { RowContent } from 'modules/OHP/applications/components/TransactionInformation';
import * as actions from '../action';
import * as c from '../constant';
import DepreciationRateModal from '../modals/DepreciationRateModal';

function DepreciationRateContent({
  handleEdit,
  handleRemove,
  depreciationRateId,
  showData,
  dataInfo,
  ordinanceRevisionId
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(depreciationRateId)) return;
    showData(depreciationRateId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(depreciationRateId)) return;
    showData(depreciationRateId);
  }, [depreciationRateId]);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DepreciationRateModal type="NEW" ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Depreciation Rate',
      modalSize: 'modal-md',
    });
  };

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-building-component font-weight-bold"
          >
            <i className="fas fa-plus" /> Add Depreciation Rate
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex mb-3">
            <div className="col-8 mt-2">
              <span className="font-weight-bold"> Information </span>
            </div>
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleEdit(dataInfo)}
                >
                  <i className="far fa-edit icon-edit" />
                </button>
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleRemove(dataInfo)}
                >
                  <i className="far fa-trash-alt icon-delete" />
                </button>
              </div>
            </div>
          </div>
          <hr />
          {!_.isEmpty(dataInfo) ? (
            <React.Fragment>
              <div className="alternate-bg-wrapper p-3 mx-3">
                <RowContent
                  label="Depreciation Rate"
                  value={_.get(dataInfo, 'attributes.depreciation_rate')}
                />
                <RowContent
                  label="From"
                  value={_.get(dataInfo, 'attributes.from')}
                />
                <RowContent
                  label="To"
                  value={_.get(dataInfo, 'attributes.to')}
                />
                <RowContent
                  label="Ordinance Revision"
                  value={_.get(dataInfo, 'attributes.ordinance_revision_name')}
                />
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )
          }
        </div>
      </div>
    </>
  );
}

DepreciationRateContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  depreciationRateId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo:
    _.get(api, `${c.SHOW_DATA}.item`) || {},
  depreciationRateId: _.get(match, 'params.depreciationRateId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DepreciationRateContent);